<template>
  <div>
    <h5>示范条款</h5>
    <p>凡因本合同引起的或与本合同有关的任何争议，均应提交中国海事仲裁委员会，按照申请仲裁时该会现行有效的《网上仲裁规则》进行仲裁。仲裁裁决是终局的，对各方均有约束力。各方同意仲裁文件按照如下电子送达地址进行送达：</p>
    <p>甲方：中国海事仲裁委员会网上仲裁平台及/或电子邮箱：</p>
    <p>手机号码：</p>
    <p>乙方：中国海事仲裁委员会网上仲裁平台及/或电子邮箱：</p>
    <p>手机号码：</p>
   </div>
</template>

<script>
export default {
  name: "guide"
}
</script>

<style scoped>
  h5 {
    text-align: center;
    padding: 6px 0;
    font-weight: bold;
    font-size: 18px;
  }
  p {
    font-size: 14px;
    text-indent: 2em;
    line-height: 28px;
    margin-bottom: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/guide/components/demo.vue